import React, { useEffect } from 'react'

const money = (v) =>
  'R' +
  Number(v || 0)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const BookingFeeBreakdownModal = ({
  bookingFee,
  karamaleFee,
  karamaleRate,
  gatewayFlatFee,
  gatewayRate,
  finalEstimatedGatewayFee,
  onClose,
}) => {
  // close on Escape + lock background scroll while open
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose()
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [onClose])

  return (
    <div className="fm-overlay" onClick={onClose} role="presentation">
      <div
        className="fm-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="fm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="fm-head">
          <div>
            <div className="fm-title" id="fm-title">
              Booking fee breakdown
            </div>
            <div className="fm-sub">Tiered by ticket price to keep things fair.</div>
          </div>
          <button type="button" className="fm-x" onClick={onClose} aria-label="Close">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div className="fm-rows">
          <div className="fm-row">
            <div className="fm-row__l">
              <span className="fm-row__name">Karamale service fee</span>
              <span className="fm-row__note">
                {(Number(karamaleRate) * 100).toFixed(2)}% · platform &amp; organiser tools
              </span>
            </div>
            <span className="fm-row__amt">{money(karamaleFee)}</span>
          </div>

          <div className="fm-row">
            <div className="fm-row__l">
              <span className="fm-row__name">Payment processing</span>
              <span className="fm-row__note">
                {(Number(gatewayRate) * 100).toFixed(1)}% + {money(gatewayFlatFee)} · secure gateway
              </span>
            </div>
            <span className="fm-row__amt">{money(finalEstimatedGatewayFee)}</span>
          </div>
        </div>

        <div className="fm-total">
          <span>Total booking fee</span>
          <b>{money(bookingFee)}</b>
        </div>

        <div className="fm-foot">Every rand is accounted for. No hidden charges.</div>

        <button type="button" className="fm-close" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  )
}

export default BookingFeeBreakdownModal
